<template>
    <div class="login-modal-backdrop">
        <div class="login-modal-warp" id="id-need-up">
            <div class="login-modal-header">
                {{ $t("common.Registered") }}
                <div
                    class="close-btn ico ico-btn-close"
                    @click="closeSelf()"
                ></div>
            </div>
            <div class="login-modal-body-warp">
                <div :style="'height:0.5rem'"></div>
                <UserName ref="account" @check-event="checkState()"></UserName>
                <div :style="'height:0.5rem'"></div>
                <Password ref="password" @check-event="checkState()"></Password>

                <div :style="'height:0.5rem'"></div>
                <OTP
                    ref="verify"
                    @on-sendcode="onSendCode()"
                    @check-event="checkState()"
                ></OTP>

                <div :style="'height:0.5rem'"></div>
                <div
                    :class="{
                        'login-modal-btn-red': isCanLogin,
                        'login-modal-btn-gray': !isCanLogin,
                    }"
                    @click="createAccount()"
                >
                    {{ $t("common.Register") }}
                </div>
            </div>
        </div>
        <MessageBox v-if="false"></MessageBox>
    </div>
</template>
<script>
import UserName from "../common/input_user_name";
import Password from "../common/input_user_password";
import OTP from "../common/input_user_otp";
import MessageBox from "../common/modal_message_box";
import ServerManager from "../../interface/server";
import tools from "../../utils/fun";
import eventConfig from "../../baseConfig/eventConfig";
import AnalystManager from "../../utils/analyst";

export default {
    name: "retrieve",
    components: {
        UserName,
        Password,
        OTP,
        MessageBox,
    },
    props: {},
    data() {
        return {
            userName: "",
            password: "",
            userCode: "",
            isCanLogin: false,
        };
    },
    destroyed() {
        tools.off(eventConfig.autoSetCode);
    },
    mounted() {
        tools.on(eventConfig.autoSetCode, (info) => {
            this.autoSetVerifyCode(info.code);
        });
    },
    methods: {
        autoSetVerifyCode(code) {
            console.log("autoSetVerifyCode:", code);
            this.$refs.verify.$data.code = code;

            this.$refs.account.$data.userName = this.$store.state.common.tempUserName;
            this.$refs.password.$data.password = this.$store.state.common.tempPass;
            this.createAccount();
        },
        checkState() {
            console.log("checkState");
            this.isCanLogin = false;

            this.$store.commit(
                "common/setTempUserName",
                this.$refs.account.$data.userName
            );
            this.$store.commit(
                "common/setTempPass",
                this.$refs.password.$data.password
            );
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.verify.checkCode();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk ||
                !this.$refs.verify.$data.isOk
            ) {
                return;
            }
            this.isCanLogin = true;
        },
        closeSelf() {
            tools.emit(eventConfig.playEffect, "pop");
            this.$emit("on-close");
        },
        OK() {
            this.$emit("on-ok");
        },
        createAccount() {
            this.$refs.password.checkPassword();
            this.$refs.account.checkAccount();
            this.$refs.verify.checkCode();
            if (
                !this.$refs.password.$data.isOk ||
                !this.$refs.account.$data.isOk ||
                !this.$refs.verify.$data.isOk
            ) {
                return;
            }
            this.userName = this.$refs.account.$data.userName;
            this.userName = this.userName.trim();
            tools.setLoadingState(true);
            ServerManager.CheckAccount(
                this,
                this.userName,
                (data) => {
                    console.log(data);
                    tools.setLoadingState(false);
                    if (data.result == 1) {
                        if (data.data == 0) {
                            this.checkCode();
                        } else {
                            this.$refs.account.showError(
                                "The email has already been registered. "
                            );
                        }
                    } else {
                        this.$refs.account.showError("Invalid email address");
                    }
                },
                () => {
                    tools.setLoadingState(false);
                    //this.$refs.account.showError("Invalid email address");
                }
            );
        },
        onSendCode() {
            this.$refs.account.checkAccount();
            if (!this.$refs.account.$data.isOk) {
                return;
            }
            this.userName = this.$refs.account.$data.userName;
            this.userName = this.userName.trim();
            tools.setLoadingState(true);

            //this.$refs.verify.startTime();
            ServerManager.sendEmailCode(
                this,
                this.userName,
                "in",
                (data) => {
                    AnalystManager.event(
                        this,
                        eventConfig.google.login.EVENT,
                        eventConfig.google.login.MAIL_SEND,
                        null,
                        AnalystManager.getActionStamp(eventConfig.google.login.MAIL_EVENT)
                    );

                    tools.setLoadingState(false);
                    console.log(data);
                    this.$refs.verify.startTime();
                },
                (errcode) => {
                    tools.setLoadingState(false);
                },
                9
            );
            AnalystManager.updateActionStamp(eventConfig.google.login.MAIL_EVENT);
            AnalystManager.event(
                this,
                eventConfig.google.login.EVENT,
                eventConfig.google.login.MAIL_PRESS
            );
        },
        register(codeReference) {
            this.password = this.$refs.password.$data.password;
            this.userName = this.$refs.account.$data.userName;
            this.cacheCodeReference = codeReference;
            tools.setLoadingState(true);
            ServerManager.register(
                this,
                this.userName,
                this.password,
                "in",
                codeReference,
                (data) => {
                    tools.setLoadingState(false);
                    this.$store.commit("common/setTempUserName", "");
                    this.$store.commit("common/setTempPass", "");
                    setTimeout(() => {
                        this.getUserAction();
                    }, 600);

                    AnalystManager.event(
                        this,
                        eventConfig.google.login.EVENT,
                        eventConfig.google.login.MAIL_SUCCESS,
                        null,
                        AnalystManager.getActionStamp(eventConfig.google.login.MAIL_EVENT)
                    );
                    //af 注册上报
                    window.AndroidBridge && window.AndroidBridge.afCompleteRegistration && window.AndroidBridge.afCompleteRegistration("email");
                },
                (err) => {
                    tools.setLoadingState(false);
                    tools.emit(eventConfig.LOGIN_ERROR, err);
                }
            );
        },
        getUserAction() {
            tools.setLoadingState(true);
            ServerManager.getUserInfo(
                this,
                (data) => {
                    tools.setLoadingState(false);
                    console.log(data);
                    this.closeSelf();
                },
                (error) => {
                    tools.setLoadingState(false);
                }
            );
        },
        checkCode() {
            this.userCode = this.$refs.verify.$data.code;
            tools.setLoadingState(true);
            ServerManager.checkEmailCode(
                this,
                this.userName,
                "in",
                this.userCode,
                (codeReference) => {
                    tools.setLoadingState(false);
                    this.register(codeReference);
                },
                (errcode) => {
                    tools.setLoadingState(false);
                    tools.emit(eventConfig.CODE_ERROR, errcode);
                },
                9
            );
            AnalystManager.event(
                this,
                eventConfig.google.login.EVENT,
                eventConfig.google.login.MAIL_CHECKER,
                null,
                AnalystManager.getActionStamp(eventConfig.google.login.MAIL_EVENT)
            );
        },
    },
};
</script>

<style >
@import "../../assets/spritesmith-generated/home.css";
@import "../../assets/css/login.css";
</style>



// WEBPACK FOOTER //
// src/components/login/rummy_register.vue